/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/comps/IndexTabBar.tsx
 * @Description: 移动端首页导航菜单
 *
 */
import { useRouter } from 'next/router';
import { Tabbar } from 'react-vant';
import IconFont from './IconFont';
import { useContext } from 'react';
import { UserContext } from '@/libs/contexts';
import { USER_TYPE, isCurrentUserType } from '@/libs/user';
const routes = [
  {
    path: '/',
    icon: {
      inActive: 'icon-mobile-footer-nav-home1',
      active: 'icon-mobile-footer-nav-home2',
    },
    name: '首页',
  },
  {
    path: '/category',
    icon: {
      inActive: 'icon-mobile-footer-nav-classification1',
      active: 'icon-mobile-footer-nav-classification2',
    },
    name: '分类',
  },
  {
    path: '/buy-more',
    icon: {
      inActive: 'icon-a-mobile-footer-nav-Frequentpurchase1',
      active: 'icon-a-mobile-footer-nav-Frequentpurchase2',
    },
    name: '常购',
  },
  {
    path: '/pages/cart',
    icon: {
      inActive: 'icon-mobile-footer-nav-Shopping1',
      active: 'icon-mobile-footer-nav-Shopping2',
    },
    name: '购物车',
  },
  {
    path: '/mine',
    icon: {
      inActive: 'icon-mobile-footer-nav-my1',
      active: 'icon-mobile-footer-nav-my2',
    },
    name: '我的',
  },
].filter(Boolean);
const SupplierRoutes = [
  {
    path: '/',
    icon: {
      inActive: 'icon-mobile-footer-nav-home1',
      active: 'icon-mobile-footer-nav-home2',
    },
    name: '首页',
  },
  // {
  //   path: '/category',
  //   icon: {
  //     inActive: 'icon-mobile-footer-nav-classification1',
  //     active: 'icon-mobile-footer-nav-classification2',
  //   },
  //   name: '分类',
  // },
  // {
  //   path: '/buy-more',
  //   icon: {
  //     inActive: 'icon-a-mobile-footer-nav-Frequentpurchase1',
  //     active: 'icon-a-mobile-footer-nav-Frequentpurchase2',
  //   },
  //   name: '常购',
  // },
  // {
  //   path: '/pages/cart',
  //   icon: {
  //     inActive: 'icon-mobile-footer-nav-Shopping1',
  //     active: 'icon-mobile-footer-nav-Shopping2',
  //   },
  //   name: '购物车',
  // },
  {
    path: '/mine',
    icon: {
      inActive: 'icon-mobile-footer-nav-my1',
      active: 'icon-mobile-footer-nav-my2',
    },
    name: '我的',
  },
].filter(Boolean);

function getActivePath(pathname: string, navRoutes: typeof routes) {
  // 精确匹配优先；首页 `/` 单独处理，避免所有路径都包含 `/`
  const exactIndex = navRoutes.findIndex((item) => item.path === pathname);
  if (exactIndex >= 0) return exactIndex;
  if (pathname === '/') return 0;
  const startsWithIndex = navRoutes.findIndex(
    (item) => item.path !== '/' && pathname.startsWith(item.path),
  );
  return startsWithIndex >= 0 ? startsWithIndex : 0;
}

type IndexTabBarProps = {
  fixed?: boolean;
  safeAreaInsetBottom?: boolean;
};
/**
 *
 * tab切换导航组件
 * @param {boolean} fixed -  是否固定
 * @param {boolean} safeAreaInsetBottom - 是否固定地区选择栏
 * @returns {JSX.Element}
 */
export default function IndexTabBar({
  fixed = true,
  safeAreaInsetBottom = false,
}: IndexTabBarProps) {
  const userInfo = useContext(UserContext);
  const { pathname, ...route } = useRouter();
  const handleClick = (routeItem) => route.push(routeItem.path);
  const NavBarRoutes =
    //   TODO 20231220 判断当前用户身份 采购、供应、运营、个人
    isCurrentUserType(userInfo, USER_TYPE.SUPPLIER) ||
    isCurrentUserType(userInfo, USER_TYPE.SUPPLIER_PARTNER) ||
    isCurrentUserType(userInfo, USER_TYPE.SUPPLY_CHAIN) ||
    isCurrentUserType(userInfo, USER_TYPE.OPERATIONS_MANAGEMENT)
      ? SupplierRoutes
      : routes;
  const activeIndex = getActivePath(pathname, NavBarRoutes);
  return (
    <Tabbar
      fixed={fixed}
      safeAreaInsetBottom={safeAreaInsetBottom}
      value={activeIndex}
      activeColor="#0080FF"
      inactiveColor="#000000"
      zIndex={100}
    >
      {NavBarRoutes.map((routeItem, index) => (
        <Tabbar.Item
          icon={(active: boolean) =>
            IconFont({
              className: routeItem.icon[active ? 'active' : 'inActive'],
              style: {
                fontSize: '16px',
              },
            })
          }
          key={index}
          onClick={() => handleClick(routeItem)}
        >
          {routeItem.name}
        </Tabbar.Item>
      ))}
    </Tabbar>
  );
}
